import React from 'react';

import { SortCriterion } from '../components/UI/Sorter';
import { SVF } from '../types/Siniestro/types';

// Ordenar por id descendente (más reciente primero)
const compareByIdDesc = (a: SVF, b: SVF) => b.id - a.id;

const reintegros_sortCriteria: SortCriterion<SVF>[] = [
  {
    key: 'todos',
    label: 'Todos',
    compare: compareByIdDesc,
  },
  {
    key: 'enviado',
    label: 'Enviado',
    filter: (svf) => svf.estado === 'ENVIADO',
    compare: compareByIdDesc,
  },
  {
    key: 'completado',
    label: 'Completado',
    filter: (svf) => svf.estado === 'COMPLETADO',
    compare: compareByIdDesc,
  },
  {
    key: 'pendiente',
    label: 'Pendiente',
    filter: (svf) => svf.estado === 'PENDIENTE',
    compare: compareByIdDesc,
  },
];

type IndicacionEstado = 'PENDIENTE' | 'ENVIADO' | 'COMPLETADO' | 'CANCELADO';

const MENSAJES_POR_ESTADO: Record<IndicacionEstado, (nombre: string) => string> = {
  PENDIENTE: (nombre) =>
    `El ${nombre} todavía no ha completado la información solicitada. Estamos aguardando a que se expida para continuar con la gestión.`,

  ENVIADO: (nombre) =>
    `La indicación fue enviada correctamente al ${nombre}. Una vez que complete la información correspondiente, podrás ver el avance aquí.`,

  COMPLETADO: (nombre) =>
    `El ${nombre} ya completó la información requerida. La gestión se encuentra finalizada y lista para revisión.`,

  CANCELADO: () =>
    `La indicación fue cancelada. Si considerás que se trata de un error, por favor contactá con tu veterinario.`,
};

const getIndicacionMensaje = (estado: IndicacionEstado, vetNombre?: string): string => {
  const nombre = vetNombre ? `Dr. ${vetNombre}` : 'el veterinario';

  return (
    MENSAJES_POR_ESTADO[estado]?.(nombre) ??
    `El ${nombre} aún no ha completado la información solicitada. Te notificaremos cuando haya novedades.`
  );
};

const acortarNombreVet = (nombreCompleto: string): string => {
  if (!nombreCompleto) return '';

  const palabras = nombreCompleto.trim().split(/\s+/);

  if (palabras.length <= 2) {
    return nombreCompleto;
  }

  return `${palabras[0]} ${palabras[palabras.length - 1]}`;
};

const destacarVetName = (mensaje: string) => {
  // Captura "Dr." seguido del nombre (1-3 palabras, sin incluir puntos ni palabras clave)
  const regex = /(Dr\.\s+[^\s.]+(?:\s+(?!todavía|ya|aún)[^\s.]+){0,2})/gi;
  const partes = mensaje.split(regex);

  return partes.map((parte, index) => {
    if (parte && /^Dr\./i.test(parte)) {
      return (
        <span key={index} className="reintegro-card__veterinario-nombre">
          {parte}
        </span>
      );
    }
    return parte;
  });
};

export { reintegros_sortCriteria, getIndicacionMensaje, acortarNombreVet, destacarVetName };
